import { GalleryImages } from '@/entities/catalog-inside-page/GalleryImages/ui/GalleryImages'
import './ui/GalleryImages.scss'
export default GalleryImages
